
import {computed, ComputedRef, defineComponent, onMounted, ref, Ref, watch} from "vue";

const __default__ = defineComponent({
  props: {
    /** Tells whether the checkmark will be marked (checked?) or not. */
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    /** Progress of the bar (0 to 100). */
    progress: {
      type: Number,
      required: false,
      default: 0
    },
    /** Tells whether the progress is blocked. */
    blocked: {
      type: Boolean,
      required: false,
      default: false
    },
    /** Tells if the content_provider is coming soon */
    upcoming: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    /** Color of the border of the checkmark. */
    const borderColor: ComputedRef<"#319f49" | "#b1b1b176"> = computed(() => {
      const green = "#319f49";
      const gray = "#b1b1b176";
      return props.checked ? green : gray;
    });

    /** Div responsible for being filled with the progress. */
    const circularProgressBar: Ref<HTMLDivElement | null> = ref(null);

    onMounted(() => {
      setProgressOfBar(props.progress);
    });

    watch(
        () => props.progress,
        () => {
          setProgressOfBar(props.progress);
        }
    );

    /** Sets the progress of the circular progress bar.
     * @param progress The progress (number from 0 to 100).
     */
    const setProgressOfBar = (progress: number): void => {
      if (circularProgressBar.value) {
        circularProgressBar.value.style.background = `
        conic-gradient(
          #1ac945 ${progress * 3.6}deg,
          #00000045 0deg
        )`;
      }
    };

    return {
      borderColor,
      circularProgressBar
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "287444e0": (_ctx.borderColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__